import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addtocart, incrementProductQuantity } from "../redux/product/actions";

export default function ProductItem({ product }) {
  const dispatch = useDispatch();
  const { cart } = useSelector((store) => store.product);
  const { product_id, title, category, url, quantity, price } = product || {};

  function productAddToCart() {
    // check product that already add to cart
    if (cart.filter((pd) => pd.product_id === product_id)?.length > 0) {
      dispatch(incrementProductQuantity(product_id));
    } else {
      dispatch(addtocart({ ...product, total_product: quantity }));
    }
  }

  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={url} alt="product" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{title}</h4>
        <p className="lws-productCategory">{category}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">
            BDT <span className="lws-price">{price}</span>
          </p>
          <p className="productQuantity">
            QTY <span className="lws-quantity">{quantity}</span>
          </p>
        </div>
        <button
          disabled={quantity === 0}
          onClick={productAddToCart}
          className="lws-btnAddToCart"
        >
          Add To Cart
        </button>
      </div>
    </div>
  );
}
